/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { AuthState, Auth0ContextInterface } from "./types";

/**
 * The initial auth state.
 */
export const initialAuthState: AuthState = {
  isLoading: true,
};

const stub = (): never => {
  throw new Error("You forgot to wrap your component in <Auth0Provider>.");
};

const initialContext = {
  ...initialAuthState,
  checkSession: stub,
  getTokenSilently: stub,
  getIdTokenClaims: stub,
  loginWithRedirect: stub,
  logout: stub,
  handleRedirectCallback: stub,
};

export const Auth0Context =
  React.createContext<Auth0ContextInterface>(initialContext);
